import { render } from "./ChatWithHuman.vue?vue&type=template&id=fd060132&scoped=true"
import script from "./ChatWithHuman.vue?vue&type=script&lang=js"
export * from "./ChatWithHuman.vue?vue&type=script&lang=js"

import "./ChatWithHuman.vue?vue&type=style&index=0&id=fd060132&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd060132"]])

export default __exports__